export default function NoPolicemanError() {
  return (
    <>
      <h1
        style={{
          fontSize: "1.4rem",
          textAlign: "center",
          marginTop: "4rem",
          color: "var(--white)",
        }}
      >
        Nenhum pronta resposta associado.
      </h1>
      <h1
        style={{
          fontSize: "1.4rem",
          textAlign: "center",
          marginTop: "1rem",
          color: "var(--white)",
        }}
      >
        Associe um pronta resposta antes de realizar essa ação.
      </h1>
    </>
  );
}
